export const tabs = {
    AMOUNT: "AMOUNT",
    DETAILS: "DETAILS",
    PAYMENT: "PAYMENT"
}